export default __webpack_public_path__ + "static/media/rightArrow.50b8fd96.svg";